export default { 
    view: "Search", 
    controller: "Search"
}